export function SectionCardGrid(props) {
    return (
        <div
            className={`grid gap-16 xl:gap-24 ${
                props.className ? props.className : ""
            }`}
        >
            {props.children}
        </div>
    );
}
